import clientSettingsQuery from 'my-phorest/components/clients/overview/client-settings.graphql';
import { getClientOverviewValidationSchema } from 'my-phorest/components/clients/overview/validation';
import clientsQuery from 'my-phorest/gql/queries/clients.graphql';

// Taken from app/components/clients/overview/index.js - to be shared with search code

// Utility function to fetch client settings
export async function fetchClientSettings(apollo, isNewClient) {
  let business = await apollo.query(
    {
      query: clientSettingsQuery,
    },
    'business'
  );

  let validationSchema = getClientOverviewValidationSchema(
    business.clientSettings,
    {},
    isNewClient
  );

  return {
    clientSettings: business.clientSettings,
    validationSchema,
  };
}

export function createEmptyClientUtility(
  clientSettings,
  clientSearch,
  session
) {
  let { searchProperties } = clientSearch;
  let isAustralianSalon = session.business.locale.countryCode === 'AU';

  let data = {
    ...searchProperties,
    hasChanges: clientSearch.isSearchPropertiesPresent,

    address: { country: {} },

    marketingEmailOptout: isAustralianSalon
      ? clientSettings.defaultEmailMarketingOptOut
      : true,
    marketingSmsOptout: isAustralianSalon
      ? clientSettings.defaultSmsMarketingOptOut
      : true,
    treatCard: {
      serial: null,
      matrixDisabled: false,
    },
  };
  return data;
}

export async function handleDuplicateMobile(
  revalidate,
  apollo,
  intl,
  clientSettings,
  linkedClient,
  mobile,
  currentClientId = null
) {
  if (!mobile) {
    return { duplicationWasHandled: false, returnedLinkedClient: null };
  }
  if (linkedClient) {
    revalidate(
      getClientOverviewValidationSchema(
        clientSettings,
        {
          phoneNumber: {
            name: 'duplicate-phone-number',
            message: intl.t('client.overview-page.this-duplicates-client', {
              name: linkedClient.name,
            }),
            value: mobile,
          },
        },
        true
      )
    );
    return { duplicationWasHandled: true, returnedLinkedClient: linkedClient };
  }

  let duplicateClients;

  try {
    duplicateClients = await apollo.query(
      {
        query: clientsQuery,
        variables: {
          filterBy: {
            phone: mobile,
          },
        },
      },
      'clients'
    );
  } catch (e) {
    return { duplicationWasHandled: false, returnedLinkedClient: null };
  }

  if (duplicateClients.edges?.length) {
    let returnedLinkedClient = duplicateClients.edges[0].node;

    // Ignore the current client's own mobile number during editing
    if (returnedLinkedClient.id === currentClientId) {
      return { duplicationWasHandled: false, returnedLinkedClient: null };
    }

    // Handle validation and display the error message
    revalidate(
      getClientOverviewValidationSchema(
        clientSettings,
        {
          phoneNumber: {
            name: 'duplicate-phone-number',
            message: intl.t('client.overview-page.this-duplicates-client', {
              name: returnedLinkedClient.name,
            }),
            value: mobile,
          },
        },
        true
      )
    );
    // we DID handle the duplicate mobile error: form validation message is displayed
    return { duplicationWasHandled: true, returnedLinkedClient };
  }

  // we did NOT handle the duplicate mobile error: now we show Oops notification
  return { duplicationWasHandled: false, returnedLinkedClient: null };
}
